import React, { useRef } from "react";
import { getPurchaseReport } from "../../services/Sales/SalesOrderService";
import { useState } from "react";
import { useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { useReactToPrint } from "react-to-print";
import LocalPrintshopOutlinedIcon from "@mui/icons-material/LocalPrintshopOutlined";
import { useMemo } from "react";
import { getFormattedNumber } from "../utils/textUtils";

const PurchaseReport = ({ resPacket, startDate, endDate, warehouse }) => {
  const [show, setShow] = useState(false);
  const [itemList, setItemList] = useState([]);
  const [selectedItem, setSelectedItem] = useState({});

  useEffect(() => {
    if (!show) {
      setItemList([]);
      setSelectedItem({});
    }
  }, [show]);

  const getPurchaseReportByItemId = (item) => {
    setSelectedItem(item);
    var request = {
      startDate: startDate,
      endDate: endDate,
      warehouseId: warehouse.value,
      hsnId: "",
      itemId: item.itemUuid,
    };
    getPurchaseReport(request).then((res) => {
      if (res.responsePacket) {
        setItemList(res.responsePacket);
        setShow(true);
      }
    });
  };

  const componentRef = useRef();
  const handleReactToPrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const handlePrint = () => {
    setTimeout(() => {
      handleReactToPrint();
    }, 1000);
  };

  const total = useMemo(() => {
    let acc = {
      unitQty: {},
      unitAmount: {},
      totalUnitQty: 0,
      totalUnitAmount: 0,
      totalAmountWithTax: 0,
    };
    for (let i = 0; i < itemList.length; i++) {
      const cur = itemList[i];
      // Calculation for Quantity
      if (acc.unitQty[cur.unit]) {
        acc.unitQty[cur.unit] += cur.quantity;
        acc.totalUnitQty += cur.quantity;
      } else {
        acc.unitQty[cur.unit] = cur.quantity;
        acc.totalUnitQty += cur.quantity;
      }

      // Calculation for Amount
      if (acc.unitAmount[cur.unit]) {
        acc.unitAmount[cur.unit] += cur.amount;
        acc.totalUnitAmount += cur.amount;
        acc.totalAmountWithTax =
          acc.totalAmountWithTax +
          cur.amount +
          Number(cur.tcsRate) +
          (Number(cur.amount) * Number(cur.taxRate)) / 100;
      } else {
        acc.unitAmount[cur.unit] = cur.amount;
        acc.totalUnitAmount += cur.amount;
        acc.totalAmountWithTax =
          acc.totalAmountWithTax +
          cur.amount +
          Number(cur.tcsRate) +
          (Number(cur.amount) * Number(cur.taxRate)) / 100;
      }
    }
    return acc;
  }, [itemList]);
  return (
    <>
      {resPacket?.length > 0 ? (
        <div className="customTable"  id="scroll">
          <table className="customTable w-100">
            <thead className="fixed-thead">
              <tr>
                <td>SNO.</td>
                <td>ITEM</td>
                <td>ITEM CATEGORY</td>
                <td>ITEM SUB CATEGORY</td>
                <td>PACK QTY.</td>
                <td>OPEN QTY.</td>
                <td>TAX RATE</td>
                <td>AMOUNT</td>
              </tr>
            </thead>
            <tbody className="body-scroll-custom">
              {resPacket.map((a, i) => (
                <tr
                  key={i}
                  onClick={() => getPurchaseReportByItemId(a)}
                  style={{ cursor: "pointer" }}
                >
                  <td>{i + 1}</td>
                  <td className="item-title-blue">{`${a.itemTitle} (${a.hsnSac})`}</td>
                  <td className="">{a.category}</td>
                  <td className="">{a.subCategory}</td>
                  <td>
                    {" "}
                    {a.itemList.map(
                      (item, i) =>
                        item.isPackUnit && (
                          <div key={i} className="mx-2">
                            {`${getFormattedNumber(item.quantity)} ${
                              item.unit
                            }`}
                          </div>
                        )
                    )}
                  </td>
                  <td>
                    {a.itemList.map(
                      (item, i) =>
                        !item.isPackUnit && (
                          <div key={i} className="mx-2">
                            {`${getFormattedNumber(item.quantity)} ${
                              item.unit
                            }`}
                          </div>
                        )
                    )}
                  </td>
                  <td>{`${getFormattedNumber(a.itemList[0].taxRate)} %`}</td>
                  <td>
                    {(
                      a.itemList.reduce((acc, item) => {
                        return (
                          acc +
                          (Number(item.amount) * Number(item.taxRate)) / 100 +
                          Number(item.amount)
                        );
                      }, 0) + a.tcsRate
                    ).toFixed(2)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <>No Record found</>
      )}
      {show && (
        <Modal show={show} onHide={() => setShow(false)} size="xl">
          <div className="d-flex justify-content-between mt-3 mx-4">
            <h3 className="font-size-20">Purchase Report</h3>
            {/* <button className="btn btn-primary py-2" onClick={handlePrint}>
              <LocalPrintshopOutlinedIcon />
            </button> */}
          </div>
          <Modal.Body>
            <div
              className="custom-table-div standardTable"
              ref={componentRef}
              id="pdf"
              style={{ width: "100%", margin: "15px", color: "black" }}
            >
              <div className="row p-3 align-items-center">
                <div className="col-5">
                  <h2 className="font-size-18 font-weight-bold">{`${
                    selectedItem.itemTitle
                  } (${itemList && itemList[0].hsnSac})`}</h2>
                </div>
                <div className="col-7">
                  <div className="d-flex justify-content-end align-items-center">
                    <span className="mr-5">Start Date: {startDate}</span>
                    <span>End Date: {endDate}</span>
                  </div>
                </div>
              </div>
              <hr style={{ backgroundColor: "#ececec" }} />
              <div>
                {itemList?.length > 0 ? (
                  <>
                    <table className="table">
                      <thead>
                        <tr>
                          <th>SNO.</th>
                          <th>Bill No.</th>
                          <th>Bill Date</th>
                          <th>Vendor Name</th>
                          <th>Purchased Stock</th>
                          <th>Rate</th>
                          <th>Tax Rate(%)</th>
                          <th>Amount</th>
                          <th>Total Amount</th>
                        </tr>
                      </thead>

                      <tbody>
                        {itemList.map((a, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td>{a.billNumber}</td>
                            <td>{a.billDate}</td>
                            <td>{a.vendorTitle}</td>
                            <td>
                              {Number(a.quantity)?.toFixed(2)}
                              &nbsp;{a.unit}
                            </td>
                            <td>{Number(a.rate)?.toFixed(2)}</td>
                            <td>{Number(a.taxRate)?.toFixed(2)}</td>
                            <td>{Number(a.amount)?.toFixed(2)}</td>
                            <td>
                              {(
                                Number(a.amount) +
                                Number(a.tcsRate) +
                                Number(a.taxesAmount)
                              )?.toFixed(2)}
                            </td>
                          </tr>
                        ))}
                        <tr>
                          <td className="border-bottom" colSpan={4}></td>
                          <td className="border-bottom">
                            {Object.keys(total["unitQty"]).map((unit, i) => {
                              return (
                                <>
                                  <div
                                    key={"unitQty" + i}
                                    className=" pl-0 border-top-grey"
                                  >
                                    <b>{`${total["unitQty"][unit].toFixed(
                                      2
                                    )} ${unit}`}</b>
                                  </div>
                                </>
                              );
                            })}
                          </td>
                          <td className="border-bottom"></td>
                          <td className="border-bottom"></td>
                          <td className="border-bottom">
                            {Object.keys(total["unitAmount"]).map((key, i) => {
                              return (
                                <>
                                  <div
                                    key={"unitAmount" + i}
                                    className="border-top-grey"
                                  >
                                    <b>{total["unitAmount"][key].toFixed(2)}</b>
                                  </div>
                                </>
                              );
                            })}
                          </td>
                          <td className="border-bottom"></td>
                        </tr>
                        <tr>
                          <td></td>
                          <td colSpan={5}>
                            <b>Total</b>
                          </td>
                          {/* <td><b>{total["totalUnitQty"].toFixed(2)}</b> </td> */}
                          <td></td>
                          <td>
                            <b>{total["totalUnitAmount"].toFixed(2)}</b>
                          </td>
                          <td>
                            <b>{total["totalAmountWithTax"].toFixed(2)}</b>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </>
                ) : (
                  <>No Record found</>
                )}
              </div>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export default PurchaseReport;
